import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemCollectOnlineIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M19 0.25H5C3.48 0.25 2.25 1.48 2.25 3V21C2.25 22.52 3.48 23.75 5 23.75H19C20.52 23.75 21.75 22.52 21.75 21V3C21.75 1.48 20.52 0.25 19 0.25ZM20.25 21C20.25 21.69 19.69 22.25 19 22.25H5C4.31 22.25 3.75 21.69 3.75 21V3C3.75 2.31 4.31 1.75 5 1.75H19C19.69 1.75 20.25 2.31 20.25 3V21Z"
        fill={color}
      />
      <path
        d="M12.31 9.46C12.12 9.35 11.88 9.35 11.68 9.46L7.38001 11.96C7.19001 12.07 7.07001 12.28 7.07001 12.5V17.5C7.07001 17.72 7.19001 17.93 7.38001 18.04L11.68 20.54C11.87 20.65 12.11 20.65 12.31 20.54L16.61 18.04C16.8 17.93 16.92 17.72 16.92 17.5V12.5C16.92 12.28 16.8 12.07 16.61 11.96L12.31 9.46ZM11.38 18.91L8.33001 17.14V13.62L11.38 15.36V18.91ZM12 14.28L8.91001 12.52L12 10.73L15.09 12.52L12 14.28ZM15.67 17.14L12.62 18.91V15.36L15.67 13.62V17.14Z"
        fill={color}
      />
      <path
        d="M12 3.38C10.22 3.38 8.48002 4 7.10002 5.13C6.83002 5.35 6.79002 5.74001 7.01002 6.01C7.23002 6.28 7.62002 6.32 7.89002 6.1C9.04002 5.16 10.5 4.64 11.99 4.64C13.48 4.64 14.94 5.16 16.09 6.1C16.36 6.32 16.75 6.28 16.97 6.01C17.19 5.74001 17.15 5.35 16.88 5.13C15.51 4 13.77 3.38 11.98 3.38H12Z"
        fill={color}
      />
      <path
        d="M9.60998 8.44C10.88 7.18 13.12 7.18 14.39 8.44C14.64 8.68 15.03 8.68 15.27 8.44C15.51 8.19 15.51 7.8 15.27 7.56C14.4 6.7 13.24 6.22 12 6.22C10.76 6.22 9.59998 6.7 8.72998 7.56C8.47998 7.8 8.47998 8.2 8.72998 8.44C8.96998 8.69 9.36998 8.69 9.60998 8.44Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemCollectOnlineIcon.displayName = 'ItemCollectOnlineIcon';
